// src/services/authService.js

import httpService from './httpService';
import { API_ROUTES } from '../config/apiRoutes';

class AuthService {
    async login(username, password) {
        const response = await API_ROUTES.LOGIN(username, password);

        if (response.data.token) {
            localStorage.setItem('token', response.data.token);
        }

        if (response.data.user) {
            localStorage.setItem('user', JSON.stringify(response.data.user));
        }

        return response.data;
    }

    async logout() {
        try {
            await httpService.post(API_ROUTES.AUTH.LOGOUT);
        } catch (error) {
            console.error('Logout error:', error);
        } finally {
            localStorage.removeItem('token');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('user');
        }
    }

    async getProfile() {
        const response = await httpService.get(API_ROUTES.USER.PROFILE);
        return response.data;
    }
}

export const authService = new AuthService();